import { getTariffFromCookie } from '../parts/ui';

jQuery(document).ready(function ($) {
    const block = $('.form-block');
    const tariff_input = block.find('[name="form-tariff"]');
    if (!block.get(0)) return;

    function setTarifFromCookie() {
        const cookie = $.cookie('user_tariff') ?? '';
        const { id = '' } = getTariffFromCookie(cookie) ?? {};
        tariff_input.val(id);
    }

    setTarifFromCookie();
    jQuery(document.body).on('set_tariff_cookies', setTarifFromCookie);
});
